import { useController } from 'react-hook-form'

import type { FormFieldCheckboxGroupProps } from './type'

import { FormFieldWrapper, InputCheckboxGroup } from '@/components/ui'

export const FormFieldCheckboxGroup = ({
  label,
  options,
  disabled,
  direction,
  name,
  control,
  error,
  showError,
}: FormFieldCheckboxGroupProps) => {
  const {
    field: { onChange, value },
  } = useController({ name, control })

  return (
    <FormFieldWrapper label={label} error={error} showError={showError}>
      <InputCheckboxGroup
        label={label}
        options={options}
        selected={value ?? []}
        disabled={disabled}
        direction={direction}
        handleChange={(value) => {
          onChange(value)
        }}
      />
    </FormFieldWrapper>
  )
}
